import { Card } from '@uhg-abyss/web/ui/Card';
import React from 'react';

/**
 * WithCard
 *
 * Conditionally wraps the children in a Card component.
 *
 * @param backgroundColor
 * @param children
 * @param withCard
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export function WithCard({ backgroundColor = 'transparent', children, withCard = true }) {
  if (withCard === false) {
    return children;
  }

  return (
    <Card className="widget-inner" css={{ backgroundColor }} size="small">
      {children}
    </Card>
  );
}
